import {useMutation} from "@apollo/client";
import {SubmitRefereeReportDocument, SubmitRefereeReportInput} from "generated/graphql";

export const useSubmitRefereeReport = () => {
  const [mutate] = useMutation(SubmitRefereeReportDocument, {
    update(cache, { data }) {
      const ev = data?.submitRefereeReport.event;
      if (!ev) return;
      cache.modify({
        id: `Article:${ev.articleId}`,
        fields: {
          events: (existing: readonly any[]) => [ev, ...existing]
        }
      })
    }
  });

  return (input: SubmitRefereeReportInput) => mutate({ variables: { input } });
}